import React from "react";
import styles from "./index.module.scss";

export default function WebListViewSkeleton() {
  return (
    <div className={styles.webListViewSkeleton}>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Account</th>
            <th>Contact</th>
            <th>Interest Score</th>
            <th>Status</th>
            <th>Time Remaining</th>
            <th>Account Owner</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 10 }).map((_, index) => (
            <tr key={index} className={styles.skeletonRow}>
              <td>
                <div className={styles.arrow}></div>
              </td>
              <td>
                <div className={styles.accountName}></div>
              </td>
              <td>
                <div className={styles.contacts}>
                  <div className={styles.name}></div>
                  <div className={styles.email}></div>
                </div>
              </td>
              <td>
                <div className={styles.score}></div>
              </td>
              <td>
                <div className={styles.status}></div>
              </td>
              <td>
                <div className={styles.timer}></div>
              </td>
              <td>
                <div className={styles.owner}></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
